module.exports = __webpack_public_path__ + "4bbada0b0355fed0e941f8101e73359a.svg";